<template>
  <div class="pc-pro-content">
    <h3 class="shop_product_title">
      <p>热销单品推荐</p>
      <span class="swiper-arrow" v-if="data.data.length > viewNum">
        <i :class="['el-icon-arrow-left', data.name + '-prev']" ref="swiperButtonPrev" title="上一页" @click="swiperPrev"></i>
        <i :class="['el-icon-arrow-right', data.name + '-next']" ref="swiperButtonNext"  title="下一页" @click="swiperNext"></i>
      </span>
    </h3>
    <div style="display: flex; margin: 0 -20px;">
      <div :class="['swiper-container', data.name]" style="width: 100%; padding: 20px;">
        <div class="swiper-wrapper">
          <div v-for="(slide, index) in data.data" :key="index" class="swiper-slide product-list">
            <router-link :to="`/product-detail?id=${slide.id}`" target="_blank">
              <img :src="slide.pic" />
              <div class="product-content">
                <p class="product-name" :title="slide.name">{{ slide.name }}</p>
                <div class="price" v-if="isLogin">
                  <span>￥<em>{{ slide.price | moneyFilters }}</em></span>
                  <span class="crossedPrice" v-if="slide.crossedPrice!=slide.price">￥<em>{{ slide.crossedPrice | moneyFilters }}</em></span>
                </div>
                <div class="price" v-else>
                  <span class="tips">官方建议零售价：￥<em>{{ slide.crossedPrice | moneyFilters }}</em></span>
                  <!-- <p class="tips">登录/注册会员即可享受会员价</p> -->
                  <Tip></Tip>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper/js/swiper'
import 'swiper/css/swiper.css'
import Tip from '@/components/Tip'
export default {
  props: ['data'],
  components: {
    Tip
  },
  data () {
    return {
      isLogin: this.$store.getters.status,
      viewNum: 4
    }
  },
  watch: {
    'data.data' (val) {
      let t = setTimeout(() => {
        this.initSwiper()
        clearTimeout(t)
      }, 50)
    }
  },
  methods: {
    initSwiper () {
      this.data.swiperItem = new Swiper('.' + this.data.name, {
        slidesPerView: this.viewNum,
        slidesPerGroup: this.viewNum,
        initialSlide: 0, // 初始显示第1个
        spaceBetween: 20,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false // 点击切换后，可以继续自动轮播
        },
        /* eslint-disable */
        loop: this.data.data.length > this.viewNum ? true : false,
        /* eslint-enable */
        observer: true,
        observeParents: true
      })
    },
    swiperPrev () {
      this.data.swiperItem.slidePrev()
    },
    swiperNext () {
      this.data.swiperItem.slideNext()
    }
  },
  mounted () {
    let t = setTimeout(() => {
      this.initSwiper()
      clearTimeout(t)
    }, 50)
  },
  destroyed () {
    this.data.swiperItem = null
  }
}
</script>

<style lang="scss" scoped>
  .pc-pro-content {
    .shop_product_title {
      font-size: 18px;
      margin-top: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-left: 0;
    }
    @media only screen and (max-width: 768px) {
      .shop_product_title {
        font-size: 16px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/IndexProSwiper.vue